/**
 * Sim (x, y) ground plane → three.js (x, height, -y), y-up. With this mapping a sim
 * facing θ (CCW from +x) is exactly `object.rotation.y = θ` for an object whose front is +x.
 */
import * as THREE from 'three';
import type { Vec2 } from '@keystone/sim';

export const toThree = (p: Vec2, height = 0, out = new THREE.Vector3()): THREE.Vector3 => out.set(p.x, height, -p.y);

export const fromThree = (v: THREE.Vector3): Vec2 => ({ x: v.x, y: -v.z });

/** Lay an XY-plane geometry flat on the ground (shape x → sim x, shape y → sim y). */
export function layFlat(mesh: THREE.Object3D): THREE.Object3D {
  mesh.rotation.x = -Math.PI / 2;
  return mesh;
}

export const color = (c: string | number): THREE.Color => new THREE.Color(c);
